import { render, staticRenderFns } from "./AdminCorrectiveActions.vue?vue&type=template&id=4dd22548&scoped=true"
import script from "./AdminCorrectiveActions.vue?vue&type=script&lang=js"
export * from "./AdminCorrectiveActions.vue?vue&type=script&lang=js"
import style0 from "./AdminCorrectiveActions.vue?vue&type=style&index=0&id=4dd22548&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd22548",
  null
  
)

export default component.exports